export default {
  LK: {
    pageTitle: "Espace personnel",
    subscription: {
      yourSubs: "Votre abonnement",
      plan_1: "Plan gratuit",
      plan_2: "Plan étendu",
      plan_3: "Plan individuel",
      changePlan: "Changer de plan",
      activeFor: "Actif jusqu'au",
      nextPayment: "Prochain paiement",
      accessFor: "L'accès est ouvert jusqu'au",
      expired: "Expiré",
    },
    eduSubs: "Abonnement éducatif",
    settings: "Paramètres",
    form: {
      labels: {
        status: "Statut",
        spec_med: "Spécialisation",
        position: "Poste",
        university: "Université",
      },
    },
    verifyBanner: {
      step1: {
        title: "Vérifiez votre compte",
        agenda:
          "La vérification est obligatoire pour accéder au téléchargement et au traitement des études alimentées par l'IA",
        status: "Statut",
      },
      step2: {
        title: "Vérifiez votre compte",
        agenda:
          "La vérification est obligatoire pour accéder au téléchargement et au traitement des études alimentées par l'IA",
        chooseVerifyWay: "Choisissez une méthode de vérification",
        ways: {
          1: "Diplôme, certificat ou carte professionnelle",
          2: "Lien vers votre profil vérifié sur un agrégateur médical (ProDoctorov, DocDoc, etc.)",
          3: "Lien vers votre profil sur le site Web de la clinique",
          4: "Téléchargez votre diplôme d'études médicales",
          5: "Téléchargez votre carte d'étudiant en médecine",
        },
        selectFile: "Sélectionner un fichier",
        sendToCheck: "Soumettre pour vérification",
        pasteLink: "Collez le lien",
        notAllowedFile: "Seuls les formats PDF et image sont autorisés.",
        noMoreFiles: "Nombre maximal de fichiers : ",
      },
      step3: {
        processing: {
          title: "Document envoyé pour examen",
          text1_1:
            "Vos informations sont en cours de vérification. Nous les examinerons sous peu et vous informerons du statut de votre demande. Cela prend généralement un jour ouvré.",
        },
        rejected: {
          title: "Compte non vérifié",
          text1_1:
            "Votre soumission n'a pas été vérifiée. Veuillez fournir des informations valides. La vérification est requise pour accéder au téléchargement et au traitement des études assistées par l'IA.",
          text1_2: "Réessayer",
        },
        accepted: {
          title: "Compte vérifié",
          text1_1:
            "Vous avez maintenant accès au téléchargement et au traitement des études à l'aide de l'intelligence artificielle.",
        },
      },
    },
  },
};
